import get from "lodash.get";

/** True when the current charity takes donations through GiveSpark, i.e. has no custom donation URL. */
export const selectUsesGiveSpark = (state): boolean =>
  !get(
    state,
    `firebase.data.${state.user?.currentCharity?.id}.config.customDonationUrl`
  );

/** Marks the `key` column disabled (hidden) when the charity does not use GiveSpark. */
export const hideColumnWithoutGiveSpark = <T extends { key: string; isDisabled: boolean }>(
  columns: T[],
  key: string,
  usesGiveSpark: boolean
): T[] =>
  usesGiveSpark
    ? columns
    : columns.map(c => (c.key === key ? { ...c, isDisabled: true } : c));
